<template>
  <v-container>
    <v-alert
      type="success"
    >
      {{ message }}
    </v-alert>
  </v-container>
</template>

<script>
export default {
  props: {
    message: {
      type: String,
      default: ()=>null
    },
  },
}
</script>